import { render, staticRenderFns } from "./TelephoneInput.vue?vue&type=template&id=673fda9e"
import script from "./TelephoneInput.vue?vue&type=script&lang=js"
export * from "./TelephoneInput.vue?vue&type=script&lang=js"
import style0 from "./TelephoneInput.vue?vue&type=style&index=0&id=673fda9e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports